import SearcherAndVector from './SearcherAndVector';

export default SearcherAndVector;